import React, { useRef, useState } from 'react';
import moment from 'moment';
import Steps from 'modals/ModalController/Steps';
import CheckboxStep from './CheckboxStep';
import SelectStudentsStep from './SelectStudentsStep';

function SendAssessmentV2({ onClose }) {
  const stepsRef = useRef(null);

  // default to the full previous calendar month (e.g. on 7/3 → 6/1–6/30)
  const payloadShape = {
    withProgressOnly: true,
    studentIds: [],
    filters: {
      startDate: moment()
        .subtract(1, 'month')
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: moment()
        .subtract(1, 'month')
        .endOf('month')
        .format('YYYY-MM-DD')
    }
  };

  const [data, setData] = useState(payloadShape);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggleInclude = () => {
    setData(state => ({ ...state, withProgressOnly: !state.withProgressOnly }));
  };

  const setStudents = ids => {
    setData(state => ({ ...state, studentIds: ids }));
  };

  const setFilters = filters => {
    setData(state => ({ ...state, filters }));
  };

  const goToCheckbox = () => stepsRef.current.goToStep('checkbox');
  const goToStudents = () => stepsRef.current.goToStep('students');

  const onSubmit = async () => {
    setIsSubmitting(true);
    try {
      const { startDate, endDate } = data.filters;
      const start_time = `${startDate} 00:00:00`;
      const end_time = `${endDate} 00:00:00`;

      await req.assesmentsShare({
        with_progress_only: data.withProgressOnly,
        kid_ids: data.studentIds,
        start_time,
        end_time
      });

      onClose();
      Actions.showFlash('Portfolios sent');
    } catch (err) {
      Actions.reportError('Unable to send the portfolio', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Steps ref={stepsRef} startStep={0}>
      <Steps.Item name="checkbox">
        <CheckboxStep
          nextStep={goToStudents}
          data={data}
          onToggle={toggleInclude}
          filters={data.filters}
          onFiltersUpdate={setFilters}
        />
      </Steps.Item>

      <Steps.Item name="students">
        <SelectStudentsStep
          onBack={goToCheckbox}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          selectedIds={data.studentIds}
          onSelect={setStudents}
          filters={data.filters}
          onFiltersUpdate={setFilters}
          buttonText="Send Portfolio"
          StepSlot={() => (
            <span>
              <strong>Step 2</strong> / 2
            </span>
          )}
        />
      </Steps.Item>
    </Steps>
  );
}

export default SendAssessmentV2;
